export enum SignInPageState {
  SignIn = 'signIn',
  PasswordReset = 'passwordReset',
  MFA = 'mfa',
  NewPassword = 'newPassword',
  TOTPSetup = 'TOTPSetup',
}
